import React from "react";
import T from "prop-types";
import cn from "classnames";

import { isEmpty, isFunction } from "2g-utils-common";
import { PlaceholderText } from "2g-placeholder";

export default function createBaseRenderer({
  name,
  content: Content,
  className,
  placeholderText = "Lorem ipsum"
}) {
  function BaseRenderer({ val, showPlaceholder }) {
    if (showPlaceholder)
      return <PlaceholderText>{placeholderText}</PlaceholderText>;
    if (isEmpty(val)) return null;
    return (
      <span
        className={cn(
          `b2b-Renderer b2b-Renderer--${name}`,
          isFunction(className) ? className(val) : undefined
        )}
      >
        <Content val={val} />
      </span>
    );
  }

  BaseRenderer.propTypes = {
    val: T.any,
    showPlaceholder: T.bool
  };

  return React.memo(BaseRenderer);
}
